import { useContext } from 'react';

import { ShoppingCartContext } from './index';

export function useShoppingCart() {
  return useContext(ShoppingCartContext);
}
